(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Opzioni_ticketDeleteController',Opzioni_ticketDeleteController);

    Opzioni_ticketDeleteController.$inject = ['$uibModalInstance', 'entity', 'Opzioni_ticket'];

    function Opzioni_ticketDeleteController($uibModalInstance, entity, Opzioni_ticket) {
        var vm = this;

        vm.opzioni_ticket = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Opzioni_ticket.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
